import * as React from 'react';
import { PropsWithChildren } from 'react';

export const NavbarNav: React.FC<PropsWithChildren<React.HTMLProps<HTMLElement>>> = ({ children, ...others }) => (
    <nav className="collapse navbar-collapse" {...others}>
        {children}
    </nav>
);
